import * as yup from "yup";
import { CHAR_LIMITS, phoneRegexByCountry } from "../../config/constants";
import { fetchCountryCode, fetchDialCode } from "../../../../reusable/country";
const validationSchema = yup.object({
	// Organizer info validations
	organiser_name: yup.string().required("Name is required"),

	organiser_email: yup
		.string()
		.required("Email is required")
		.email("Enter a valid email"),

	organiser_phone: yup
		.number()
		.typeError("Please enter phone number")
		.integer("Please provide an integer")
		.test("valid-phone", "The phone number entered appears to be invalid", (val, context) => {
			if (!val) return true; // Allow empty value if not required
			const country = context?.parent?.organiser_country_code ? context?.parent?.organiser_country_code?.toUpperCase() : fetchCountryCode();
			const dailcode = context?.parent?.organiser_dial_code ? context?.parent?.organiser_dial_code : fetchDialCode();
			const filterVal = `${dailcode}${val}`;
			const regex = phoneRegexByCountry[country];
			if (!regex) {
				return true; // If no regex is defined for the country, skip validation
			}
			return regex.test(filterVal);
		}),

	organiser_website: yup.string().url("Please enter a valid URL"),

	organizer_facebook_url: yup
		.string()
		.url("Please enter a valid URL")
		// .test("facebook", "Enter a valid facebook url", val => {
		// 	if (val == undefined || val == "") return true;
		// 	else if (val.includes("facebook.com")) return true;
		// 	else return false;
		// })
		// .matches(/(?:https?:\/\/)?(?:www\.)?(?:facebook|fb|m\.facebook)\.(?:com|me)\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[\w\-]*\/)*([\w\-\.]+)(?:\/)?/i, "Please enter a valid Facebook Profile URL")
		.max(160, "facebook url should not exceed 160 characters"),

	organizer_twitter_url: yup
		.string()
		.url("Please enter a valid URL")
		// .test("twitter", "Enter a valid twitter url", val => {
		// 	if (val == undefined || val == "") return true;
		// 	else if (val.includes("twitter.com")) return true;
		// 	else return false;
		// })
		// .matches(/http(?:s)?:\/\/(?:www\.)?twitter\.com\/([a-zA-Z0-9_]+)/, "Please enter a valid Twitter Profile URL")
		.max(160, "twitter url should not exceed 160 characters"),

	organizer_linkedin_url: yup
		.string()
		.url("Please enter a valid URL")
		// .test("linkedin", "Enter a valid LinkedIn URL", (val) => {
		// 	if (!val || val === "") {
		// 		return true;
		// 	} else if (val.includes("linkedin.com")) {
		// 		return true;
		// 	} else {
		// 		return false;
		// 	}
		// })
		// .matches(
		// 	/http(?:s)?:\/\/(?:www\.)?linkedin\.com\/([a-zA-Z0-9_]+)/,
		// 	"Please enter a valid LinkedIn Profile URL"
		// )
		.max(160, "LinkedIn URL should not exceed 160 characters"),
	organiser_info: yup
		.string()
		.max(CHAR_LIMITS.organizer.descMax, "You have reached maximum characters limit"),
});

export default validationSchema;